import {Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {Invoice} from '../../model/invoice';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {InvoicePeerService} from '../../service/invoice-peer.service';
import {NotificationLogsResource} from '../../model/model-resource';
import {tap} from 'rxjs/operators';
import {ObjectQueryFilterOperator, ObjectQueryParameters, ObjectQuerySortDirection} from '../../model/object-query-parameters';
import {NotificationLog} from '../../model/notification-log';
import {UsersMap, UsersMapCache} from '../../model/model-map-cache';

@Component({
  selector: 'app-invoice-notifications-widget',
  templateUrl: './invoice-notifications-widget.component.html',
  styleUrls: ['./invoice-notifications-widget.component.scss']
})
export class InvoiceNotificationsWidgetComponent implements OnInit {

  invoice$: Observable<Invoice>;
  notificationLogs$: Observable<NotificationLog[]>;
  usersMap$: Observable<UsersMap>;

  invoice: Invoice;
  selectedItem: NotificationLog;
  notificationChoices = [
    {value: true, label: NotificationLog.resolveLabel(true)},
    {value: false, label: NotificationLog.resolveLabel(false)}
  ];

  form: UntypedFormGroup;
  locked = false;
  added = false;
  saving = false;

  constructor(
    private invoicePeerService: InvoicePeerService,
    private notificationsLogResource: NotificationLogsResource,
    private usersMapCache: UsersMapCache,
    private builder: UntypedFormBuilder) {
    this.form = this.builder.group({
      notification: [null, Validators.required],
      changed: [null, Validators.required]
    });
  }

  add(): void {
    this.invoicePeerService.lock();
    this.added = true;
    this.form.reset();
    this.form.patchValue({
      notification: true,
      changed: new Date()
    });
  }

  revert(): void {
    this.invoicePeerService.unlock();
    this.added = false;
  }

  save(): void {
    this.saving = true;
    const notificationLog = new NotificationLog();
    notificationLog.invoiceId = this.invoice.invoiceId;
    notificationLog.notification = this.form.value.notification;
    notificationLog.changed = this.form.value.changed;
    this.notificationsLogResource.save(notificationLog).subscribe(() => {
      this.invoicePeerService.unlock();
      this.selectedItem = null;
      this.saving = false;
      this.added = false;
      this.notificationLogs$ = this.getNotificationLogs(this.invoice.invoiceId);
    });
  }

  itemClicked(item) {
    this.selectedItem = (item !== this.selectedItem ? item : null);
  }

  ngOnInit() {

    this.usersMap$ = this.usersMapCache.map$

    this.invoice$ = this.invoicePeerService
      .get()
      .pipe(
        tap(invoice => {
            this.invoice = invoice;
            this.notificationLogs$ = this.getNotificationLogs(invoice.invoiceId);
          }
        ));

    this.invoicePeerService.getState().subscribe((state) => {
      if (state === 'locked') {
        this.locked = true;
      } else if (state === 'unlocked') {
        this.locked = false;
      }
    });
  }

  private getNotificationLogs(invoiceId: number): Observable<NotificationLog[]> {
    const params = new ObjectQueryParameters();
    params.addFilter('invoiceId', ObjectQueryFilterOperator.Equals, invoiceId.toString());
    params.addSort('changed', ObjectQuerySortDirection.Descending);
    params.addSort('notificationLogId', ObjectQuerySortDirection.Descending);
    return this.notificationsLogResource
      .query(params);
  }

}
